import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../styles/component/header_footer/header_gaeste.css";
import media from "../../util/img_loader.js";
import { CartContext } from "../../context/cartcontext.js";
import { useAuth } from "../../context/auth_context.js";

function Header_gaeste() {
    const navigate = useNavigate();
    const { cart } = useContext(CartContext);
    const { user, logout } = useAuth();
    const { clearCart } = useContext(CartContext);

    const [productMenuOpen, setProductMenuOpen] = useState(false);
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleLogout = () => {
        logout(clearCart);
        setUserMenuOpen(false);
        setIsMobileMenuOpen(false);
    };

    const displayNames = {
        Guertel: "Gürtel",
        Tasche: "Taschen",
        Portmoney: "Portemonnaie",
        Key: "Schlüsselanhänger",
        Handy: "Handyhülle",
        Accessory: "Accessoires",
        Sonstige: "Sonstiges"
    };

    return (
        <header>
            <div className="header-container">


                <div className="burger" onClick={() => setIsMobileMenuOpen(prev => !prev)}>
                    ☰ Produktliste
                </div>

                <nav className={`nav ${isMobileMenuOpen ? "active" : ""}`}>
                    <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>Home</Link>

                    <div
                        className="dropdown"
                        onMouseEnter={() => setProductMenuOpen(true)}
                        onMouseLeave={() => setProductMenuOpen(false)}
                    >
                        <span className="dropdown-title">Produkte ▾</span>
                        {productMenuOpen && (
                            <div className="dropdown-menu">
                                {["Guertel", "Tasche", "Portmoney", "Key", "Handy", "Accessory", "Sonstige"].map((cat) => (
                                    <Link key={cat} to={`/products/${cat}`} onClick={() => setIsMobileMenuOpen(false)}>
                                        {displayNames[cat]}
                                    </Link>
                                ))}
                            </div>
                        )}
                    </div>

                    <Link to="/about" onClick={() => setIsMobileMenuOpen(false)}>Über mich</Link>
                    <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>Kontakt</Link>
                    <Link to="/feedback" onClick={() => setIsMobileMenuOpen(false)}>⭐Kundenstimmen</Link>
                </nav>
                <div className="logo-container">
                    <Link to="/">
                        <img src={media["logo/Logo_nurleder.png"]} alt="Logo" className="logo" style={{ width: "120px", height: "auto" }} />

                    </Link>
                </div>
                <div className="user-actions">
                    {user ? (
                        <div
                            className="dropdown"
                            onMouseEnter={() => setUserMenuOpen(true)}
                            onMouseLeave={() => setUserMenuOpen(false)}
                        >
                            <span className="dropdown-title">👤 Hallo {user.name} ▾</span>
                            {userMenuOpen && (
                                <div className="dropdown-menu">

                                    <Link to="/" onClick={handleLogout}>🚪 Abmelden</Link>
                                </div>
                            )}
                        </div>
                    ) : (
                        <Link className="action login-link" to="/login">👤 Anmelden/Registrieren</Link>
                    )}

                    <div className="action" onClick={() => {
                        navigate("/cart");
                        setIsMobileMenuOpen(false);
                    }}>
                        🛒 <span>Warenkorb</span>
                        <span className="cart-count">({cart.length})</span>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header_gaeste; 